import React from 'react'
import ToggleSwitch from '../../../../../Common/Switch/ToggleSwitch'

const PreferencesTab = () => {
    let isEnabled = true;
    return (
        <div className="my-3">
            <form>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    {/* Currency and Time Zone Inputs */}
                    <div className='w-full'>
                        <label htmlFor="currency" className="text-dark text-lg font-normal">Currency</label>
                        <input
                            type="text"
                            className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id='currency'
                            placeholder="USD"
                            required
                        />
                    </div>
                    <div className='w-full'>
                        <label htmlFor="time-zone" className="text-dark text-lg font-normal">Time Zone</label>
                        <input
                            type="text"
                            className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="time-zone"
                            placeholder="(GMT-12:00) International Date Line West"
                            required
                        />
                    </div>

                    {/* Notification Heading */}
                    <div className="sm:col-span-2">
                        <p className="text-dark text-lg font-medium">Notification</p>
                    </div>

                    {/* Toggle Switches */}
                    <div className="sm:col-span-2 flex flex-col gap-4">
                        <ToggleSwitch label="I send or receive digital currency" initial={isEnabled} />
                        <ToggleSwitch label="I send or receive digital currency" />
                        <ToggleSwitch label="I send or receive digital currency" initial={isEnabled} />
                    </div>

                    {/* Save Button */}
                    <div className="sm:col-span-2 mt-3 self-end">
                        <button type="submit" className="bg-primary-900 text-white hover:bg-primary-800 rounded-lg py-2 px-10 w-full md:w-auto mt-3">Save</button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default PreferencesTab